import swiper from "swiper";
import isMobile from "../../plugins/is-mobile.js";

if ($(".l-largePlace__slider .slider .swiper-slide").length > 1) {
  //サムネイル
  if (!isMobile(768)) {
    var sliderThumbnail = new swiper(".thumbnail", {
      slidesPerView: "auto",
      freeMode: false,
      observer: true,
      allowTouchMove: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 3,
      breakpoints: {
        768: {
          spaceBetween: 10,
        },
      },
    });
  }

  //スライダー
  var slider = new swiper(".slider", {
    slidesPerView: "auto",
    freeMode: false,
    observer: false,
    allowTouchMove: false,
    speed: 1200,
    thumbs: {
      swiper: (!isMobile(768)) ? sliderThumbnail : "",
    },
    pagination: {
      el: ".slider-pagenation",
      clickable: true,
    },
    navigation: {
      nextEl: ".-next",
      prevEl: ".-prev",
    },
    breakpoints: {
      768: {
        thumbs: {
          swiper: "",
        },
        allowTouchMove: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
    },
  });
} else {
  $(".l-largePlace__slider").addClass("col-1");
}
